import { getBaseUrl } from 'services/api/api-client/helpers.ts';
import axios from 'axios';

export const downloadFile = (url: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_self';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadOrOpenBlobFile = async (
  documentUrl: string,
  documentName: string,
  isOpen?: boolean,
) => {
  const url = getBaseUrl() + '/api/share-point?uri=' + documentUrl;
  const extension = documentUrl.slice(documentUrl.lastIndexOf('.') + 1);

  const response = await axios.get(url, {
    responseType: 'blob',
  });

  const blob = response.data;
  const downloadUrl = window.URL.createObjectURL(blob);

  if (isOpen) {
    window.open(downloadUrl, '_blank');
  } else {
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = `${documentName}.${extension}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  window.URL.revokeObjectURL(downloadUrl);
};
